import { InternalPosition } from "./internal-position.model";
import { Permission } from "./permission.model";

export class UserRole {

    public id: number;
    public inUse: boolean;
    public name: string;
    public isOob: boolean;
    public permissions: Permission[];
    public internalPositions: InternalPosition[];

    constructor(role: any = {}) {
        this.id = role.id;
        this.name = role.name || '';
        this.inUse = role.inUse;
        this.isOob = role.isOob;
        this.permissions = role.permissions || [];
        this.internalPositions = role.internalPositions || [];
    }

    get type() {
        return 'role';
    }
}
